<!-- <div class="row hdrBar">
<div class="col-lg-12 col-md-12 mg-a">
  <h1>Assign Vehicles For Sanitory Secratory</h1>
</div>

</div> -->
<div class="row">
  <div class="col-lg-8 col-md-8 mg-a">
    <div class="row hdrBar">
      <div class="col-lg-12 col-md-12 mg-a">
        <h1>Assign Vehicles For Sanitory Secratory</h1>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-4 mg-a">
    <button
      nz-button
      nzType="primary"
      class="adddrvrBtn"
      (click)="openSlider()"
    >
      Assign Vehicle
    </button>
  </div>
</div>
<div class="fltrbg">
  <div class="row">
    <div class="col-lg-2 col-md-2 crdCl">
      <p class="slctlbl">ULB</p>
      <nz-select
        class="slctBx"
        nzShowSearch
        [(ngModel)]="selectedtenant"
        (ngModelChange)="ontntSelect($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
        @for (t of tntLst; track t) {
        <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
        }
      </nz-select>
    </div>
    @if (ShowClap) {
    <div class="col-lg-2 col-md-2 crdCl">
      <p class="slctlbl">Vehicle Vendor</p>
      <nz-select
        class="slctBx"
        nzShowSearch
        [(ngModel)]="selectedvndr"
        (ngModelChange)="onvndrSelect($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        @if (!showVndr) {
        <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
        } @for (v of vendorList; track v) {
        <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
        }
      </nz-select>
    </div>
    }
  </div>
</div>
<div style="padding: 0px 10px">
  <div class="ds-card grid tbl dwntbl vhclsCmpnt">
    <app-data-grid
      class="p-8"
      style="width: 100%"
      [dataSource]="vhcleslst"
      [legacyColumns]="vhclslstcolumnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="true"
      exportFileName="SS assigned Vehicles Data"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
    >
    </app-data-grid>
  </div>
</div>

<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="500"
  [nzVisible]="opensldr"
  nzTitle="Assign vehicle for Sanitory Secratory"
  (nzOnClose)="closeSideBar()"
>
  <!-- <div class="row">
  <div class="col-md-12">
    <div class="sdHdr">
      Assign vehicle for Sanitory Secratory
    </div>
  </div>
</div> -->
  <form nz-form class="drvrDtlsfrm">
    <div nz-row [nzGutter]="8">
      <div nz-col nzSpan="24">
        <nz-form-label>Select Sanitory Secratory</nz-form-label>
        <nz-form-item>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Sanitory Secratory"
              [(ngModel)]="ss_id"
              [ngModelOptions]="{ standalone: true }"
            >
              @for (s of ssList; track s) {
              <nz-option [nzLabel]="s.fst_nm" [nzValue]="s.usr_id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="24">
        <nz-form-label>Select Vehicle</nz-form-label>
        <nz-form-item>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Vehicle"
              [(ngModel)]="veh_id"
              [ngModelOptions]="{ standalone: true }"
              nzMode="multiple"
              (ngModelChange)="onvehiclesselect($event)"
            >
              @for (v of asrtList; track v) {
              <nz-option
                [nzLabel]="v.asrt_nm"
                [nzValue]="v.asrt_id"
              ></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      @if (disabled) {
      <div class="clrred">* {{ errMsg }}</div>
      }
    </div>
  </form>

  <div class="btngrp">
    <button
      nz-button
      style="margin-right: 8px"
      (click)="closeSideBar()"
      nzType="primary"
      nzDanger
    >
      Cancel
    </button>
    <button nz-button (click)="saveasgnmnt()" class="sbmtbtn">Assign</button>
  </div>
</nz-drawer>
